import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";

export const renderFavoritesIcon = (isInFavorites: boolean, favoritesHandler: React.MouseEventHandler) => {
    const classNames = isInFavorites ? "i-o-fav-selected" : "";

    return (
        <div className={`rj-ev-list__ev-card__section-item rj-ev-list__ev-card__fav`} data-uat="div-ev-list-ev-card-fav">
            <EventCardIcon className={`rj-ev-list__ev-card-icon--fav`} onClick={favoritesHandler}>
                <Icon i={`i-o-fav i-o-fav-row i-12 ${classNames}`}></Icon>
            </EventCardIcon>
        </div>
    )
}